import { getCookie } from './cookie'

const TOKEN_NAME = process.env.VUE_APP_JWT_TOKEN
const JWT = getCookie(`DittoMusic[${TOKEN_NAME}]`)
const JWT_CUSTOMER = getCookie(`DittoMusic[${TOKEN_NAME}Customer]`)
const JWT_TOKEN = (JWT && JWT_CUSTOMER) ? JWT_CUSTOMER : JWT

export default JWT_TOKEN
